<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M0.00999375,7C0.00999375,7,0.00999375,5,0.00999375,5C0.00999375,5,16,5,16,5C16,5,16,12,16,12C16,12.55,15.5503,13,15.0006,13C15.0006,13,9.00437,13,9.00437,13C9.00437,13,9.00437,10.01,9.00437,10.01C8.97474,8.33168,7.64389,7,5.99625,7C5.99625,7,1.99875,7,1.99875,7C1.99875,7,0.00999375,7,0.00999375,7C0.00999375,7,0.00999375,7,0.00999375,7ZM15.0006,2C15.0006,2,7.41537,2,7.41537,2C7.41537,2,5.70643,0.29,5.70643,0.29C5.52655,0.11,5.2767,0,4.99688,0C4.99688,0,0.999375,0,0.999375,0C0.449719,0,0,0.45,0,1C0,1,0,4,0,4C0,4,15.99,4,15.99,4C15.99,4,15.99,3,15.99,3C16,2.45,15.5503,2,15.0006,2C15.0006,2,15.0006,2,15.0006,2ZM5.99625,9C5.99625,9,1.99875,9,1.99875,9C1.44909,9,0.999375,9.45,0.999375,10C0.999375,10.55,1.44909,11,1.99875,11C1.99875,11,3.58776,11,3.58776,11C3.58776,11,0.299813,14.29,0.299813,14.29C0.119925,14.47,0.00999375,14.72,0.00999375,15C0.00999375,15.55,0.459713,16,1.00937,16C1.28919,16,1.53904,15.89,1.71893,15.71C1.71893,15.71,5.00687,12.42,5.00687,12.42C5.00687,12.42,5.00687,14.01,5.00687,14.01C5.00687,14.56,5.45659,15.01,6.00625,15.01C6.5559,15.01,7.00562,14.56,7.00562,14.01C7.00562,14.01,7.00562,10.01,7.00562,10.01C6.99563,9.45,6.54591,9,5.99625,9C5.99625,9,5.99625,9,5.99625,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'AddToFolder',
} as DefineComponent
</script>
